import apiUrl from '../../../constants'
import commonFunction from '../../../commonFunction'
import constantVariable from '../../../constantVariable'
import Vue from 'vue'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import DatePicker from 'vue2-datepicker';

import {
	ModelListSelect,
	BasicSelect,
} from 'vue-search-select';

import MultiSelect from 'vue-multiselect'

  import 'vue-multiselect/dist/vue-multiselect.min.css';


import FileUpload from 'v-file-upload';

import authFunction from '../../../authFunction';

import moment from 'moment';
import JQuery from 'jquery';
let $ = JQuery

Vue.use(FileUpload);
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.filter('formatDate', function (value) {

	if (value) {
		return moment(String(value)).format('DD-MM-YYYY hh:mm')
	}

});

export default {
	name: 'holdbucket',
	components: {
		Paginate,
		DatePicker,
		ModelListSelect,
		BasicSelect,
		Loading,
		MultiSelect
	},
	data() {
		return {
			isLoadingPagination: false,
			fullPage: false,
			hubSelect: true,
			listTotalCount: 0,
			page: 'holdbucket',
			ticketLabel: 'Add Ticket',
			userTypeForTicket: '',
			ticketResultMsg: '',
			ticketResultModal: false,
			ticket: {
				disabled: false
			},
			submitted: false,
			ticketShipmentData: [],
			shipmentTickets: [],
			ticket: {},
			username: '',
			source: [],
			sourceId: '',
			zoneData: [],
			hubData: [],
			selectedZoneObj: {
				value: '',
				text: ''
			},
			selectedHubObj: {
				value: '',
				text: ''
			},
			selectedClientObj: {
				value: '',
				text: ''
			},
			selectedStatusCodeObj: {
				value: '',
				text: ''
			},
			selectedSourceObj: {
				value: '',
				text: ''
			},
			ticketType: [],
			ticketTypeId: '',
			selectedTicketObj: {
				value: '',
				text: ''
			},
			reason: [],
			reasonId: '',
			selectedReasonObj: {
				value: '',
				text: ''
			},
			subReason: [],
			subReasonId: '',
			selectedSubReasonObj: {
				value: '',
				text: ''
			},
			action: [],
			actionId: '',
			selectedActionObj: {
				value: '',
				text: ''
			},
			ticketStatus: [],
			ticketStatusId: '',
			selectedTicketStatusObj: {},
			searchOptions: [],
			searchId: '',
			selectedSearchObj: {
				value: '',
				text: ''
			},
			reAttemptDate: '',
			startDate: new Date(),
			endDate: new Date(),
			validated: false,
			format: 'YYYY-MM-DD',
			disabledDates: {
				to: new Date(Date.now() - 8640000)
			},
			address: '',
			location: '',
			selectedOrderTypeObj: {
				value: '',
				text: ''
			},
			comments: '',
			email: '',
			userid: '',
			OldDeliveryUserOrUserId: '',
			DepartmentID: '',
			DepartmentName: '',
			modalShow: false,
			modalMessageShow: false,
			displayMsg: false,
			successErrorMsg: "",
			pageCount: 0,
			pageNo: 0,
			isLoading: false,
			perPage: 50,
			resultCount: '',
			formattedDate: '',
			search: {
				criteria: 'holdbucket',
				zone: '',
				hub: '',
			},
			fromDate: '',
			toDate: '',
			tillDate1: '',
			tillDate2: '',
			clientData: [],
			statusCodeData: [],
			scawshipments: [],
			notificationTypesData: [],
			Ticketmodal: false,
			ShipmentLogModal: false,
			displayshippingid: '',
			selectAll: false,
			clientItems:[],
			lastSelectClientItem:{}
		
		}
	
	},
	created: function () {

		// this.getTrackingSource();
		// this.getSearchtags(this.search.scawtype);
		var typeList = [{
			typename: "CSAW",
		}, {
			typename: "CSAWRTO",
		}];
		this.notificationTypesData = typeList;
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date)
				return;
			return moment(date).format('DD-MM-YYYY');
		},
		momentdate: function (date) {
			if (!date)
				return;
			return moment(date).format('DD-MM-YYYY');
		},
		momenttime: function (date) {
			if (!date)
				return;
			return moment(date).format('HH:mm:ss');
		}
	},
	mounted() {
		[this.subDepartmentList, this.DepartmentID, this.userdetail, this.permissiondata, this.userTypeForTicket, this.SummarySelectOptionObj, this.SummaryOptionObj] = commonFunction.getuserDetailsAndpermissionData();
		this.accessRestrictor();
		this.userid = this.userdetail[0].userid;
		this.username = this.userdetail[0].username;
		this.userRole = this.userdetail[0].roles[0].rolename;
		this.OldDeliveryUserOrUserId = this.userdetail[0].OldDeliveryUserOrUserId;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss');
		this.getZoneList();
		this.getClientList();
		// this.getStatusCodeList(this.search.scawtype);

	}, // End computed
	methods: {
	
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).add(1, 'd').format('YYYY-MM-DD');
		},

		setClientBusinessAccountID(){
			if(this.clientItems.length==0){
				return undefined;
			}
			else return Number(this.clientItems[0].value)
		},

		selectedZone(selectedZoneData) {
			this.isLoading = true;
			this.selectedZoneObj = selectedZoneData;
			this.search.zone = selectedZoneData.value;
			this.getHubList();
		},

		selectedClientData(selectedClientData) {
			// console.log("SSSSSSSSSSSSSSSSSs")
			this.selectedClientObj = selectedClientData;
			this.search.client = selectedClientData.value;
		},
		

		selectedHubData(selectedHubData) {
			this.selectedHubObj = selectedHubData;
			this.search.hub = selectedHubData.value;
		},

		

		getClientList() {
			try {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getClientListCSAW',
						'data': {
							BusinessFlow: "Forward",
							BusinessService: "Delivery"
						},
						headers: commonFunction.getusertoken(),
					})
					.then(result => {
						// console.log("result is :",result)
						let data=result.data;
						this.clientData=data;
						// console.log("data is :",data);
						// for(let i=0;i<data.length;i++){
						// 	this.clientData.push(data[i]);
						// }
						// return;
						// var data = result.data.data.data.data;


						// for (var i = 0; i < data.length; i++) {
						// 	console.log("Data 0 is :",data[0]);
						// 	this.clientData.push({
						// 		value: data[i].ClientBusinessAccountId,
						// 		text: data[i].AccountName
						// 	})
						// }
						// console.log("client data is :",this.clientData);
					}, error => {
						console.error(error);
					});
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getClientList";
				this.$alertify.error(msg);
			}
		},
	
		getZoneList() {
			try {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getZoneList',
						'data': {},
						headers: commonFunction.getusertoken(),
					})
					.then(result => {
						var data = result.data.data.data.data;
						for (var i = 0; i < data.length; i++) {
							this.zoneData.push({
								value: data[i].hubzoneid,
								text: data[i].hubzonename
							})
						}
					}, error => {
						console.error(error);
					});
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getZoneList";
				this.$alertify.error(msg);
			}
		},

		async getHubList() {
			try {
				this.hubData = [];
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.hubSelect = true;
				this.search.hub = '';
				if (this.search.zone) {
					await axios({
							method: 'POST',
							'url': apiUrl.api_url + 'getHubList',
							'data': {
								id: this.search.zone
							},
							headers: commonFunction.getusertoken(),
						})
						.then(result => {
							this.hubSelect = false;
							var data = result.data.data.data.data;
							for (var i = 0; i < data.length; i++) {
								this.hubData.push({
									value: data[i].HubID,
									text: data[i].HubName
								})
							}
							this.isLoading = false;
						}, error => {
							this.isLoading = false;
							this.hubSelect = true;
							console.error(error);
						});
				} else {
					this.hubSelect = true;
					this.hubData = []
				}
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getHubList";
				this.$alertify.error(msg);
			}
		},
		onChange: function () {
			if (this.fromDate != null && this.toDate != null) {
				if (this.fromDate != '') {
					let dateDisabled = new Date(this.fromDate);
					this.tillDate1 = new Date();
					dateDisabled.setDate(this.fromDate.getDate() + 1);
					this.tillDate1 = dateDisabled;
				}
				if (this.toDate != '') {
					let dateDisabled2 = new Date(this.toDate);
					this.tillDate2 = new Date();
					dateDisabled2.setDate(this.toDate.getDate() - 1);
					this.tillDate2 = dateDisabled2;
				}
			} else {
				this.fromDate = '';
				this.toDate = '';
				this.tillDate1 = '';
				this.tillDate2 = '';
			}
		},

		// myFunction: function  () {
		// document.getElementById('calenderDiv').style.height = '50px';
		// },

		exportHoldBucketListing() {
			try {
					if (this.fromDate === '') {
						this.$alertify.error('Please select From Date.');
						return false;
					}
					if (this.toDate === '') {
						this.$alertify.error('Please select To Date.');
						return false;
					}

					if (this.search.hub === '' && this.search.zone != '') {
						this.$alertify.error('Please select hub after selecting zone.');
						return false;
					}
				
				let searchData = {};
				this.isLoading = true;
					searchData = {
						FromDate: this.dateFormat1(this.fromDate),
						ToDate: this.dateFormat1(this.toDate),
						ClientBusinessAccountID:this.setClientBusinessAccountID(),
						HubID: this.search.hub,
					}
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'exportHoldBucket',
						'data': searchData,
						responseType: 'blob', // important
						headers: commonFunction.getusertoken(),
					})
					.then(response => {
						this.isLoading = false;
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', 'holdBucket.xlsx');
						document.body.appendChild(link);
						link.click();

					}, error => {
						this.isLoading = false;
						this.isLoadingPagination = false;
						var commonVariable = commonFunction.showNetworkError(error);
						this.$alertify.error(commonVariable);
					});
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - exportHoldBucketListing";
				this.$alertify.error(msg);
			}
		},

		onSubmit: function (event) {
			this.$validator.validateAll().then(() => {
				event.target.reset();

			}).catch(() => {

			});
		},


		resetForm() {
			var self = this; //you need this because *this* will refer to Object.keys below`
			this.listTotalCount = 0;
			// changes by sunny
			this.hubSelect = true;
			this.scawshipments = [];
			this.fromDate = '';
			this.toDate = '';
			this.search = {
				criteria: 'holdbucket',
				zone: '',
				hub: '',
			};
			this.selectedStatusCodeObj = {
				value: '',
				text: ''
			};
			this.selectedZoneObj = {
				value: '',
				text: ''
			};
			this.selectedClientObj = {
				value: '',
				text: ''
			};
			this.selectedHubObj = {
				value: '',
				text: ''
			};
			this.clientItems=[];
		},

	
		accessRestrictor() {
			var desider = 0;
			var n = window.location.href.search('#');
			var link = window.location.href.substr(n + 1);
			var linkToo = window.location.href.substr(n + 2);
			for (let i = 0; i < this.permissiondata.length; i++) {
				if (link == this.permissiondata[i].url) {
					desider++;
				}
			}
			if (desider == 0) {
				this.$router.push('/dashboard');
				this.$alertify.error("Access Denied for " + linkToo + " Module.");
			}
		},
	

		onSelect (clientItems, lastSelectClientItem) {
			this.clientItems=[];
			this.clientItems.push(clientItems)

		  },

		//   reset () {
		// 	this.clientItems = [] // reset
		//   },
		  // select option from parent component
		//   selectOption () {
		// 	this.clientItems = _.unionWith(this.clientItems, [this.options[0]], _.isEqual)
		//   }
	} // end methods
}


// WEBPACK FOOTER //
// ./src/views/components/holdbucket/holdbucket.component.js